import * as types from './types';

const initialState = {
  tags: [],
  tagsPending: false,
  tagsSuccess: false,
  tagsFailure: false,

  selectedTag: {
    id: 0,
    name: 'All users',
  },
  selectedUsers: [],
  addTagDialog: false,

  removeUsersTagsOpen: false,
  removeUsersTagsStart: false,
  removeUsersTagsSuccess: false,
  removeUsersTagsErrors: false,
};

const tagsFetch = state => ({
  ...state,
  tagsPending: true,
  tagsSuccess: false,
  tagsFailure: false,
});

const tagsSuccess = (state, payload) => ({
  ...state,
  tags: payload,
  tagsPending: false,
  tagsSuccess: true,
  tagsFailure: false,
});

const tagsFailure = state => ({
  ...state,
  tagsPending: false,
  tagsSuccess: false,
  tagsFailure: true,
});

const selectTag = (state, payload) => ({
  ...state,
  selectedTag: payload,
});

const selectUsers = (state, newUserId) => {
  const selectedUsers = handleUserSelect(state, newUserId);

  return {
    ...state,
    selectedUsers,
  };
};

const handleUserSelect = (state, newUserId) => {
  const selectedUsers = state.selectedUsers;
  let newSelectedUsers = [];

  if (selectedUsers.includes(newUserId)) {
    newSelectedUsers = selectedUsers.filter(userId => userId !== newUserId);
  } else {
    newSelectedUsers = [...selectedUsers, newUserId];
  }

  return newSelectedUsers;
};

const toggleUserDialog = state => {
  return {
    ...state,
    addTagDialog: !state.addTagDialog,
  };
};

const clearUsersSelection = state => ({
  ...state,
  selectedUsers: [],
});

const removeUsersTagsStart = state => ({
  ...state,
  removeUsersTagsStart: true,
  removeUsersTagsSuccess: false,
  removeUsersTagsErrors: false,
});

const removeUsersTagsSuccess = state => ({
  ...state,
  removeUsersTagsStart: false,
  removeUsersTagsSuccess: true,
  removeUsersTagsErrors: false,
});

const removeUsersTagsFailure = state => ({
  ...state,
  removeUsersTagsStart: false,
  removeUsersTagsSuccess: false,
  removeUsersTagsErrors: true,
});

const toggleRemoveUsersTags = state => {
  return {
    ...state,
    removeUsersTagsOpen: !state.removeUsersTagsOpen,
  };
};

export default(state = initialState, action) => {
  switch (action.type) {
    case types.TAGS_DATA_FETCH:
      return tagsFetch(state);
    case types.TAGS_DATA_SUCCESS:
      return tagsSuccess(state, action.payload);
    case types.TAGS_DATA_FAILURE:
      return tagsFailure(state);

    case types.REMOVE_USERS_TAGS_TOGGLE:
      return toggleRemoveUsersTags(state);
    case types.REMOVE_USERS_TAGS_START:
      return removeUsersTagsStart(state);
    case types.REMOVE_USERS_TAGS_SUCCESS:
      return removeUsersTagsSuccess(state);
    case types.REMOVE_USERS_TAGS_FAILURE:
      return removeUsersTagsFailure(state);

    case types.SELECT_TAG:
      return selectTag(state, action.payload);
    case types.SELECT_USERS:
      return selectUsers(state, action.payload);
    case types.TOGGLE_ADD_TAG_DIALOG:
      return toggleUserDialog(state);
    case types.CLEAR_USERS_SELECTION:
      return clearUsersSelection(state);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/tags/index.js